<template>
  <div class="template-container" id="template-container">
    <div
      @mousedown="startDrag"
      @mousemove="dragging"
      @mouseup="endDrag"
      :style="
        'z-index:1000;width:20%;position:absolute; left: ' +
        dialogLeft +
        '; top: ' +
        dialogTop
      "
      v-show="showPanel2"
      class="sourceDialogClass"
      id="gethi"
    >
      <div class="dialog-header">
        <h1 class="dialog-title">问答</h1>
        <button class="close-button" @click="showPanel2 = false">X</button>
      </div>
      <!--             <iframe style="width:100%;height:60vh;" class="dialog-iframe" :src="'http://192.168.1.53/mcc/zhenchong_ml/wenda/#/onlyIndex?c_romid=' + this.current.c_romid"></iframe>-->
      <iframe
        style="width: 100%; height: 60vh"
        class="dialog-iframe"
        :src="iframeSrc2"
      ></iframe>
    </div>
    <div class="template-headerClass">
      <div class="template-titleClass">
        <img
          style="position: absolute; right: 100px; margin-top: 30px"
          @click="showPanel2 = !showPanel2"
          src="static/img/ai.png"
          alt="#"
        />
        <div>报告生成模板</div>
        <div class="search-input input_item">
          <input
            id="searchInput"
            class="input-box input_input"
            placeholder="请输入您的查询内容"
            type="text"
            autocomplete="off"
            maxlength="500"
            v-model="searchText"
          />
          <span
            class="small-generatePic-btn main-btn-primary btn_search"
            @click="gogogo()"
          >
            查询
          </span>
        </div>
      </div>
      <!-- <div class="explainClass">
                <div>注释：分析主要对文件进行比对，结果只说明文件重合度，不对文件质量进行评价与分析</div>
            </div>
            <div class="agileClass" v-if="false">
                <div v-for="(item, index) in agileButtonArr" :key="index">
                    <div style="display: flex;flex-direction: row;margin-right: 25px" @click="navigationEvent">
                        <img :src="item.img" alt="#" width="24px" height="24px">
                        <span style="margin-left: 10px"> {{ item.text }} </span>
                    </div>
                </div>
            </div> -->
    </div>
    <div class="template-bodyClass">
      <div
        v-for="(item, index) in templateList"
        :key="index"
        class="template-itemClass"
        :style="'cursor: pointer'"
        @click="goToDuplicateCheck(item)"
      >
        <img
          src="static/img/report/u92.svg"
          alt="#"
          width="100%"
          height="100%"
        />
        <div v-if="item.c_id === 0" class="template-toDuplicateCheckClass">
          + 新增模板
        </div>
        <div v-else class="template-cardAllClass">
          <div class="template-cardImgClass">
            <div class="template-imgPaddingClass">
              <!-- <img src="static/img/report/infoVs.svg" alt="#" width="48px" height="48px"
                                v-show="item.finish === 1"> -->
              <img
                src="static/img/report/successVs.svg"
                alt="#"
                width="48px"
                height="48px"
              />
              <!-- v-show="item.finish === 0"> -->
            </div>
            <div>
              <img
                src="static/img/report/Vs.png"
                alt="#"
                height="30px"
                width="30px"
                style="position: relative; left: 27px; top: -78px"
              />
            </div>
          </div>
          <div class="template-cardContentClass">
            <div class="template-cardTitleClass">{{ item.c_name }}</div>
            <div class="template-cardMainClass" :title="item.c_desc">
              {{ item.c_desc }}
            </div>
          </div>
          <div class="template-cardFooterClass">
            <div class="template-cardButtonClass" @click.stop="goToplan(item)">
              <el-link :underline="false">方案列表</el-link>
            </div>
            <div class="template-cardButtonClass" @click.stop="showEdit(item)">
              <el-link :underline="false">编辑</el-link>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list"
        v-for="item in row - (templateList.length % row)"
        v-if="templateList.length % row > 0"
      ></div>
      <div style="width: 100vw; height: 100px"></div>
      <el-dialog
        title="添加模板"
        :visible.sync="isShowAdd"
        width="40%"
        :before-close="handleCloseAdd"
      >
        <el-form ref="form" :model="fileForm" label-width="4rem">
          <el-form-item label="文件">
            <el-upload
              ref="uploadRef"
              class="upload-demo"
              action="#"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-success="handSuccess"
              :auto-upload="false"
            >
              <el-button class="button-confrim">选取文件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="名称">
            <el-input
              type="text"
              v-model="fileForm.name"
              placeholder="请输入模板名"
            ></el-input>
          </el-form-item>
          <el-form-item label="介绍">
            <el-input
              type="textarea"
              v-model="fileForm.desc"
              placeholder="请输入模板简介"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button class="" @click="handleCloseAdd">取 消</el-button>
          <el-button class="" @click="submitFile">提交</el-button>
        </template>
      </el-dialog>
      <el-dialog
        title="编辑模板信息"
        :visible.sync="isShowEdit"
        width="40%"
        :before-close="handleCloseEdit"
      >
        <el-form ref="form" :model="fileForm" label-width="4rem">
          <el-form-item label="名称">
            <el-input
              type="text"
              v-model="fileForm.name"
              placeholder="请输入模板名"
            ></el-input>
          </el-form-item>
          <el-form-item label="介绍">
            <el-input
              type="textarea"
              v-model="fileForm.desc"
              placeholder="请输入模板简介"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button class="" @click="handleCloseEdit">取 消</el-button>
          <el-button class="" @click="submitEdit">提交</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import templateApi from "@/api/report";
import axios from "axios";
export default {
  data() {
    return {
      iframeSrc2: "",
      dialogTop: "200px",
      dialogLeft: "0px",
      startX: 0,
      startY: 0,
      showPanel2: true,

      searchText: "",
      row: 3,
      agileButtonArr: [
        { img: "static/img/report/u233.png", text: "快速开始" },
        { img: "static/img/report/u245.png", text: "产品简介" },
        { img: "static/img/report/u239.png", text: "产品文档" },
      ],
      templateList: [],
      isShowAdd: false,
      isShowEdit: false,
      fileForm: {
        file: "",
        name: "",
        desc: "",
      },
      fileList: [],
      templateChoose: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    gogogo() {
      var templateList = [];
      for (var a = 0; a < this.templateListAll.length; a++) {
        if (this.templateListAll[a].c_name.indexOf(this.searchText) > -1) {
          templateList.push(this.templateListAll[a]);
        }
      }
      templateList.unshift({ c_id: 0, c_desc: "", c_name: "" });
      this.templateList = templateList;
    },
    handleCloseAdd() {
      this.fileList = [];
      this.fileForm = {
        file: "",
        name: "",
        desc: "",
      };
      this.isShowAdd = false;
    },
    handleCloseEdit() {
      this.fileForm = {
        file: "",
        name: "",
        desc: "",
      };
      this.isShowEdit = false;
    },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX - parseFloat(this.dialogLeft);
      this.startY = event.clientY - parseFloat(this.dialogTop);
    },
    dragging(event) {
      if (this.isDragging) {
        let dialogLeft = event.clientX - this.startX + "px";
        let dialogTop = event.clientY - this.startY + "px";
        let boxRect = document
          .getElementById("template-container")
          .getBoundingClientRect();
        const thumbRight =
          this.dialogLeft +
          document.getElementById("gethi").getBoundingClientRect().width;
        const thumbBottom =
          this.dialogTop +
          document.getElementById("gethi").getBoundingClientRect().height;
        if (dialogLeft <= 0) {
          this.dialogLeft = 0;
        }
        if (dialogTop <= 0) {
          this.dialogTop = 0;
        }
        if (thumbRight >= boxRect.width) {
          this.dialogLeft =
            boxRect.width - document.getElementById("gethi").offsetWidth;
        }
        if (thumbBottom >= boxRect.height) {
          this.dialogTop =
            boxRect.height - document.getElementById("gethi").offsetHeight;
        }
      }
    },
    endDrag() {
      this.isDragging = false;
    },
    goToDuplicateCheck(item) {
      if (item.c_id === 0) {
        this.fileList = [];
        this.fileForm = {
          file: "",
          name: "",
          desc: "",
        };
        this.isShowAdd = true;
      } else {
        this.$router.push({
          name: "PlanBuildW",
          params: { id: item.c_id, name: item.c_name },
        });
      }
    },
    getTemplateList() {
      templateApi.getTemplates().then((res) => {
        if (res.data.code === 200) {
          this.templateListAll = res.data.data;
          this.templateList = this.templateListAll;
          this.templateList.unshift({ c_id: 0, c_desc: "", c_name: "" }); //用作新增模板
          // for (let i = 0; i < 10; i++)  {

          //         this.templateList.unshift({ c_id: 1, c_desc: '', c_name: '' })

          // }
        }
      });
    },
    showEdit(item) {
      // console.log(item);
      this.fileForm.name = item.c_name;
      this.fileForm.desc = item.c_desc;
      this.templateChoose = item;
      this.isShowEdit = true;
    },
    submitEdit() {
      let formData = new FormData();
      formData.append("c_id", this.templateChoose.c_id);
      formData.append("c_name", this.fileForm.name);
      formData.append("c_desc", this.fileForm.desc);
      templateApi.editTemplate(formData).then((res) => {
        if (res.data.code === 200) {
          this.getTemplateList();
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.isShowEdit = false;
        } else {
          this.$message({
            message: "编辑失败",
            type: "error",
          });
        }
      });
    },
    navigationEvent() {
      alert("待开发！");
    },
    checkResult() {
      alert("分析结果开发中！");
    },
    goToplan(item) {
      this.$router.push({
        name: "planListW",
        params: { id: item.c_id, name: item.c_name },
      });
    },
    handleChange(file, fileList) {
      this.fileForm.file = file;
    },
    handSuccess(response, file, fileList) {
      this.$refs.uploadRef.clearFiles();
    },
    handleExceed(files, uploadFiles) {
      this.fileList = [];
      let item = files[0];
      let file = {
        name: item.name,
        percentage: 0,
        raw: item,
        size: item.size,
        status: "ready",
        uid: genFileId(),
      };
      this.fileForm.file = file;
      this.fileList.push(file);
      // state.fileToUp = files[0];
    },
    submitFile() {
      let formData = new FormData();
      formData.append("file", this.fileForm.file.raw);
      formData.append("name", this.fileForm.name);
      // formData.append("Desc", sthis.fileForm.desc)
      axios
        .post(
          "https://edam.tscon.cn:7778/python66-18004/uploadfile",
          formData,
          {
            timeout: 180000,
            headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
          }
        )
        .then((res) => {
          // console.log(res);
          if (res.status == 200 && res.data.status == 0) {
            formData.append("c_name", this.fileForm.name);
            formData.append("c_desc", this.fileForm.desc);
            formData.append("c_data", JSON.stringify(res.data.data));
            templateApi.addTemplateWithUploadFile(formData).then((res1) => {
              if (res1.data.code === 200) {
                this.getTemplateList();
                this.$message({
                  message: "上传成功",
                  type: "success",
                });
                this.isShowAdd = false;
              } else {
                this.$message({
                  message: "上传失败",
                  type: "error",
                });
              }
            });
          } else {
            this.$message({
              message: "上传至大模型或解析失败",
              type: "error",
            });
          }
        });
    },
    deleteTemplate(data) {
      this.$confirm("确定要删除这个模板", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          templateApi.removeTemplate({ c_id: data.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功");
              this.getTemplateList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  created() {},
  mounted() {
    this.getTemplateList();
    var screenHeight = window.screen.height;
    var screenWidth = window.screen.width;
    // this.dialogTop = screenHeight - divElement.offsetHeight +"px"
    this.dialogLeft = screenWidth * 0.8 - 10 + "px";
    this.iframeSrc2 =
      "https://edam.tscon.cn:7778/wenda53/mcc/zhenchong_ml/wenda/#/onlyIndex";
  },
};
</script>

<style scoped>
.btn_search {
  display: inline-block;
  box-sizing: border-box;
  width: 160px;
  height: 55px;
  margin-right: -1px;
  color: #fff;
  font-weight: 400;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-variant: tabular-nums;
  line-height: 55px;
  text-align: center;
  background-color: #624aff;
  border-radius: 0 11px 11px 0;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-direction: normal;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}

.btn_phone_search {
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  margin-right: -1px;
  color: #fff;
  font-weight: 400;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-variant: tabular-nums;
  line-height: 72px;
  text-align: center;
  background-color: #624aff;
  border-radius: 0 11px 11px 0;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-direction: normal;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
  /* width: 160px; */
}
.template-container {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

.template-headerClass {
  width: 100%;
  height: 150px;
  padding-left: 4%;
  background-color: #f0f2f5;
  box-shadow: inset 0 0 5px #b0b0b0;
}

.template-titleClass {
  padding: 2% 0;
  font-weight: bold;
  font-size: 24px;
}

.template-explainClass {
  width: 100%;
  padding-bottom: 2%;
  color: #808080;
  font-size: 16px;
}

.template-agileClass {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: #54b2ff;
}

.template-container::-webkit-scrollbar {
  width: 10px;
}

.template-container::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
}

.template-container::-webkit-scrollbar-track {
  background: url("/img/report/gunlun.png") 50% repeat-y;
  border-radius: 10px;
}

.template-bodyClass::-webkit-scrollbar {
  width: 10px;
}

.template-bodyClass::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
}

.template-bodyClass::-webkit-scrollbar-track {
  background: url("/img/report/gunlun.png") 50% repeat-y;
  border-radius: 10px;
}
.input_item {
  position: absolute;
  right: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 500px;
  height: 55px;
  padding-left: 28px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-family: "Microsoft YaHei" !important;
  font-variant: tabular-nums;
  line-height: 1.5715;
  background-color: hsla(0, 0%, 100%, 0.6);
  border: 1px solid rgba(44, 43, 71, 0.15);
  border-radius: 12px;
  box-shadow: 0 2px 6px 0 rgba(44, 43, 71, 0.05);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-align: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-box-pack: justify;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.input_input {
  box-sizing: border-box;
  width: 70%;
  height: 100%;
  margin: 0;
  margin-right: 24px;
  overflow: visible;
  color: #27264d;
  font-weight: 500;
  font-size: 26px;
  font-family: Microsoft YaHei;
  line-height: 72px;
  background: none;
  border: 0;
  outline: none;
  -webkit-appearance: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100%;
  -webkit-box-direction: normal;
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
}
.template-bodyClass {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  justify-items: center;
  width: 80%;
  height: 78%;
  padding: 1% 10%;
  overflow-y: auto;
  background-color: #ffffff;

  > div {
    margin-top: 2%;
    margin-right: 5%;
  }
}

.template-itemClass {
  position: relative;
  display: flex;
  justify-content: center;
  width: 25%;
}

.list {
  width: 25%;
  overflow: hidden;
  content: "";
}

.template-toDuplicateCheckClass {
  position: absolute;
  align-self: center;
  box-sizing: border-box;
  color: #0000006d;
}

.template-cardAllClass {
  position: absolute;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.template-cardImgClass {
  width: 25%;
  height: 75%;
  background-color: #fafafa;
}

.template-imgPaddingClass {
  img {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40% 20%;
  }
}

.template-cardContentClass {
  width: 70%;
  height: 75%;
  padding-left: 5%;
  background-color: #fafafa;
}

.template-cardTitleClass {
  width: 100%;
  height: 35%;
  padding-top: 5%;
  font-weight: bold;
}

.template-cardMainClass {
  display: -webkit-box;
  padding-right: 2%;
  overflow: hidden;
  font-size: 13px;
  font-size: 13px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.template-cardFooterClass {
  display: flex;
  width: 100%;
  height: 25%;
  background-color: #ededed;
}

.template-cardButtonClass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  cursor: pointer;
}
.sourceDialogClass {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #f0f0f0;
}

.dialog-title {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Reports/template1.vue